import React from 'react';

import { languagesMap } from '../../consts';
import { CaptionMap } from '../../types';
import ListItem from '../ListItem';

export const getLanguageItems = (captionsState: CaptionMap) =>
  languagesMap.filter((language) => !captionsState[language.value]);

export const getLanguageItemRenderer = (option: {
  flag: string;
  label: string;
  languageLabel: string;
}) => (
  <ListItem
    className="flex items-center text-icon-placeholder"
    flag={option.flag}
    label={option.label}
    languageLabel={option.languageLabel}
  />
);

export const FORM_OVERRIDES = { FieldContainer: { className: 'mb-12 text-icon-placeholder' } };

export default getLanguageItems;
